<template>
	<ViewTrainerLoader class="page-trainer">
		<ViewTrainerTrainer />
	</ViewTrainerLoader>
</template>

<script lang="ts">
	import PageBase from '@/Core/Page.vue';
	import ViewTrainerLoader from '@/App/View/Trainer/Loader.vue';
	import ViewTrainerTrainer from '@/App/View/Trainer/Trainer.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * Landing page. Boots straight into the ChalkySticks billiards trainer:
	 * ViewTrainerLoader installs the vue2-trainer plugin (showing a spinner),
	 * then ViewTrainerTrainer renders the freeplay scene which owns the HUD
	 * chrome and the "Enter VR" button.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks Quest
	 */
	@Component({
		components: {
			ViewTrainerLoader,
			ViewTrainerTrainer,
		},
	})
	export default class PageTrainer extends PageBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.page-trainer {
		height: 100%;
		width: 100%;
	}
</style>
